import { render, staticRenderFns } from "./Downloads.vue?vue&type=template&id=f8a0cee8&"
import script from "./Downloads.vue?vue&type=script&lang=js&"
export * from "./Downloads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/casperjureskog/CMM/creo-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f8a0cee8')) {
      api.createRecord('f8a0cee8', component.options)
    } else {
      api.reload('f8a0cee8', component.options)
    }
    module.hot.accept("./Downloads.vue?vue&type=template&id=f8a0cee8&", function () {
      api.rerender('f8a0cee8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/asset/Downloads.vue"
export default component.exports